import { createContext, useContext, useMemo, useState } from 'react';

import ImageViewer from './ImageViewer';

type ImageViewerAPI = {
  show: (image: string) => void;
  close: () => void;
};

const ctx = createContext<ImageViewerAPI | null>(null);
ctx.displayName = 'ImageViewerAPI';

export function ImageViewerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const api = useMemo(() => ({ show: setUrl, close: () => setUrl(null) }), []);

  return (
    <>
      <ctx.Provider value={api}>{children}</ctx.Provider>
      {url && <ImageViewer url={url} closeModal={api.close} />}
    </>
  );
}

export function useImageViewer(): ImageViewerAPI {
  return orDie(useContext(ctx));
}
